<script setup lang="ts">

//vue
import { reactive, onMounted, watch, computed, ref } from "vue";

//componentes
import { Modal } from "bootstrap";

interface IProps {
  id: string,
  exibir: boolean,
  botaoFechar?: boolean,
  botaoSim?: boolean,
  botaoConfirmar?: boolean,
  botaoNao?: boolean,
  botaoGravar?: boolean,
  botaoGravarTipo?: 'button' | 'submit'
  titulo?: string,
  classBody?: string,
  classHeader?: string,
  tamanho?: 'modal-sm' | 'modal-lg' | 'modal-xl' | 'modal-md'
}

var props = defineProps<IProps>();

const controle = reactive({
  id: props.id,
  modal: {} as Modal,
  exibir: false,
  titulo: props.titulo,
  tamanho: props.tamanho
});

// Referências para o drag
const modalDialogRef = ref<HTMLElement | null>(null);
const isDragging = ref(false);
const dragOffset = reactive({ x: 0, y: 0 });

var emit = defineEmits(["onSim", "onNao", "onOk", "onFechou", "onGravar", "onConfirmar"]);

onMounted(() => {
  if (props.id == undefined || props.id == "")
    controle.id = "janMsgBox";
})

watch(() => props.id, async (novoValor) => {
  if (novoValor == undefined || novoValor == "")
    controle.id = "janMsgBox";
  else
    controle.id = novoValor;
})

watch(() => props.exibir, async (novoValor, antigoValor) => {
  if (novoValor == true && novoValor != antigoValor) {
    controle.exibir = true;
    exibirModal();
    controle.tamanho = props.tamanho;
  }
  else
    fecharModal();
})

watch(() => props.titulo, async (novoValor) => {
  controle.titulo = novoValor;
})

watch(() => props.tamanho, async (novoValor) => {
  controle.tamanho = novoValor;
})

function exibirModal() {
  controle.modal = new Modal(`#${controle.id}`, {})
  controle.modal.show();
}

function fecharModal() {
  controle.modal.hide();
  resetModalPosition();
  emit("onFechou");
}

const temBotoes = computed(() => {
  return props.botaoFechar || props.botaoSim || props.botaoNao || props.botaoGravar || props.botaoConfirmar;
})

// Funções de drag
function onMouseDown(e: MouseEvent) {
  if (!modalDialogRef.value) return;

  isDragging.value = true;
  const rect = modalDialogRef.value.getBoundingClientRect();
  dragOffset.x = e.clientX - rect.left;
  dragOffset.y = e.clientY - rect.top;

  // Captura a largura atual antes de mudar para fixed
  modalDialogRef.value.style.width = `${rect.width}px`;

  document.addEventListener('mousemove', onMouseMove);
  document.addEventListener('mouseup', onMouseUp);
}

function onMouseMove(e: MouseEvent) {
  if (!isDragging.value || !modalDialogRef.value) return;

  const newX = e.clientX - dragOffset.x;
  const newY = e.clientY - dragOffset.y;

  modalDialogRef.value.style.position = 'fixed';
  modalDialogRef.value.style.left = `${newX}px`;
  modalDialogRef.value.style.top = `${newY}px`;
  modalDialogRef.value.style.margin = '0';
}

function onMouseUp() {
  isDragging.value = false;
  document.removeEventListener('mousemove', onMouseMove);
  document.removeEventListener('mouseup', onMouseUp);
}

function resetModalPosition() {
  if (modalDialogRef.value) {
    modalDialogRef.value.style.position = '';
    modalDialogRef.value.style.left = '';
    modalDialogRef.value.style.top = '';
    modalDialogRef.value.style.margin = '';
    modalDialogRef.value.style.width = '';
  }
}
</script>
<template>
  <div class="modal fade" :id="controle.id" tabindex="-1" data-bs-keyboard="false" data-bs-backdrop="static">
   <div class="modal-dialog modal-dialog-centered" :class="tamanho ? tamanho : ''" v-bind="$attrs"
      ref="modalDialogRef">
      <div class="modal-content">
       <div class="modal-header d-flex justify-content-between draggable-header" :class="props.classHeader"
          @mousedown="onMouseDown">
          <h5 class="modal-title fw-bold" id="exampleModalLabel">{{ !controle?.titulo ? 'Atenção' : controle.titulo }}
          </h5>
          <a type="button" class="" @click="fecharModal" @mousedown.stop>
            <i class="fa fa-times"></i>
          </a>
        </div>
        <div class="modal-body" :class="props.classBody">
          <slot></slot>
        </div>
        <div class="modal-footer p-2" v-if="temBotoes">
          <div class="row w-100 ">
            <div class="col-6 ps-0">
              <a class="btn btn-primary btn-sm " v-if="props.botaoSim" @click="() => { emit('onSim'); fecharModal(); }">
                <i class="fas fa-check" /> Sim
              </a>
             <a class="btn btn-primary btn-sm " v-if="props.botaoConfirmar"
                @click="() => { emit('onConfirmar'); fecharModal(); }">
                <i class="fas fa-check" /> Confirmar
              </a>
              <button class="btn btn-primary btn-sm " v-if="props.botaoGravar" @click="() => { emit('onGravar'); }"
                :type="botaoGravarTipo ? botaoGravarTipo : botaoGravarTipo">
                <i class="fa fa-save" /> Gravar
              </button>
            </div>
            <div class="col-6  pe-0 text-end">
              <a class="btn btn-secondary btn-sm " v-if="props.botaoNao"
                @click="() => { emit('onNao'); fecharModal(); }">
                <i class="fas fa-times" /> Não
              </a>
              <a class="btn btn-secondary btn-sm" type="button" v-if="props.botaoFechar" @click="fecharModal">
                <i class="fas fa-times" /> Fechar
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.draggable-header {
  cursor: move;
  user-select: none;
}

.draggable-header a {
  cursor: pointer;
}

</style>